import { Link } from "react-router-dom";
import { Instagram, Twitter, Linkedin, Send, MessageCircle, AtSign } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useT } from "@/lib/i18n";
import { companyLine } from "@/config/company";

const SOCIAL = [
  { icon: Instagram, url: "https://www.instagram.com/akhilesh.mishra/", label: "Instagram" },
  { icon: Twitter, url: "https://x.com/Akhileshmishras", label: "X" },
  { icon: AtSign, url: "https://www.threads.com/@akhilesh.mishra", label: "Threads" },
  { icon: MessageCircle, url: "https://wa.me/917359777788", label: "WhatsApp" },
  { icon: Send, url: "https://t.me/+WO0s40101fFiMDll", label: "Telegram" },
  { icon: Linkedin, url: "https://www.linkedin.com/in/akhilesh-mishra-61268a54/", label: "LinkedIn" },
];

const PLATFORM = [
  { to: "/cinematic-arsenal", label: "Cinematic Arsenal" },
  { to: "/how-it-works", label: "How It Works" },
  { to: "/solutions", label: "Solutions" },
  { to: "/studio", label: "Create Studio" },
];
const COMPANY = [
  { to: "/about", label: "About Swastik" },
  { to: "/enterprise", label: "Enterprise" },
  { to: "/pricing", label: "Pricing" },
  { to: "/contact", label: "Contact" },
];
const LEGAL = [
  { to: "/privacy", label: "Privacy Policy" },
  { to: "/terms", label: "Terms of Service" },
  { to: "/refunds", label: "Refund & Cancellation" },
];

export default function Footer() {
  const { t, lp } = useT();
  return (
    <footer data-testid="app-footer" className="border-t border-white/10 mt-4">
      <div className="px-6 sm:px-10 py-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8">
        <div className="lg:col-span-1">
          <Logo size={34} />
          <p className="text-xs text-slate-500 mt-3 max-w-xs">AI audio, video and music production studio by Swastik AI Labs. Real files, honest status, pay by UPI — no watermarks, no copyright, pure AI excellence.</p>
        </div>
        <div>
          <div className="text-[10px] font-mono uppercase tracking-widest text-slate-500 mb-3">{t("Platform")}</div>
          <div className="space-y-2">
            {PLATFORM.map((l) => (
              <Link key={l.to} to={lp(l.to)} data-testid={`footer-${l.to.replace("/", "")}`} className="block text-sm text-slate-400 hover:text-white transition-colors">{t(l.label)}</Link>
            ))}
          </div>
        </div>
        <div>
          <div className="text-[10px] font-mono uppercase tracking-widest text-slate-500 mb-3">{t("Company")}</div>
          <div className="space-y-2">
            {COMPANY.map((l) => (
              <Link key={l.to} to={lp(l.to)} data-testid={`footer-${l.to.replace("/", "")}`} className="block text-sm text-slate-400 hover:text-white transition-colors">{t(l.label)}</Link>
            ))}
          </div>
        </div>
        <div>
          <div className="text-[10px] font-mono uppercase tracking-widest text-slate-500 mb-3">{t("Legal")}</div>
          <div className="space-y-2">
            {LEGAL.map((l) => (
              <Link key={l.to} to={lp(l.to)} data-testid={`footer-${l.to.replace("/", "")}`} className="block text-sm text-slate-400 hover:text-white transition-colors">{t(l.label)}</Link>
            ))}
          </div>
        </div>
        <div>
          <div className="text-[10px] font-mono uppercase tracking-widest text-slate-500 mb-3">{t("Connect")}</div>
          <div className="flex flex-wrap gap-2">
            {SOCIAL.map((l) => (
              <a key={l.label} href={l.url} target="_blank" rel="noreferrer noopener" data-testid={`social-${l.label.toLowerCase()}`} title={l.label}
                className="w-9 h-9 rounded-full flex items-center justify-center border border-white/10 text-slate-400 hover:text-white hover:border-purple-500/40 hover:bg-white/5 transition-colors">
                <l.icon size={16} />
              </a>
            ))}
          </div>
        </div>
      </div>
      <div className="px-6 sm:px-10 py-4 border-t border-white/10 text-xs font-mono text-slate-600">
        © 2026 {companyLine()} · Payments via UPI
      </div>
    </footer>
  );
}
